module.exports = __webpack_public_path__ + "img/ed284fa48df71d8f6f3a783d9a9cfae5.png";